interface LojaLike {
  loja: number;
  cidade?: string | null;
  uf?: string | null;
}

/** Rótulo padrão da loja nas tabelas: "NNN - CIDADE/ESTADO". */
export function formatLojaLabel(row: LojaLike): string {
  const cidade = (row.cidade ?? "").trim();
  const uf = (row.uf ?? "").trim();
  const local = cidade && uf ? `${cidade}/${uf}` : cidade || uf;
  return local ? `${row.loja} - ${local}` : `${row.loja}`;
}
